exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".birthday-row[data-v-3ee62a61]{display:-webkit-box;display:-moz-box;display:-ms-flexbox;display:flex;gap:15px}.birthday-row .form_input[data-v-3ee62a61]{-webkit-box-flex:0;-moz-box-flex:0;-ms-flex:0 1 25%;flex:0 1 25%}.birthday-row .form_input.birthday-year[data-v-3ee62a61]{-webkit-box-flex:1;-moz-box-flex:1;-ms-flex:1;flex:1}.subtitle[data-v-3ee62a61]{font-size:13px}", ""]);

// exports
